import React, { useState } from 'react';
import { PanelGroup, Panel } from 'react-bootstrap';

/**
 * @description This Component is similar to the older HOC Accordion.jsx component. However the purpose of the
 * withAccordion component is to implement an agnostic component that can be re-used without adding implementation
 * specific logic. Any implementation logic should be added to the WrappedComponent. Only add accordion specific
 * logic to the withAccordion component.
 * @param {Component} WrappedComponent 
 * @param {[Object]} arrayList 
 * @param {Component} optionalComponent 
 */

const withAccordion = (WrappedComponent, arrayList, optionalComponent = accordionSuggestionPanel) => props => {
    const { options } = props
    const [activeKey, setActiveKey] = useState('')

    const handleSelect = activeKey => {
        setActiveKey(activeKey)
    }

    return (
        <PanelGroup
            accordion
            id="accordion-group"
            activeKey={activeKey}
            onSelect={handleSelect}
        >
            {arrayList.map((item, index) => {
                const hideClass = !!options[index].hideElement ? options[index].hideElement : ''
                return (
                    <Panel eventKey={index} key={index} className={hideClass}>
                        <Panel.Heading>
                            <WrappedComponent {...props} option={options[index]} />
                            <Panel.Title toggle />
                        </Panel.Heading>
                        <Panel.Body collapsible>
                            {optionalComponent(arrayList[index])}
                        </Panel.Body>
                    </Panel>
                );
            })}
        </PanelGroup>
    )
}

const accordionSuggestionPanel = ({ head, subHeader, body, footer }) => {
    return (
        <div className="suggestion-box text-left">
            {head && (
                <div className="mb">
                    <strong>{head}</strong>:<span className="text-success ml">{subHeader}</span>
                </div>
            )}
            <div>
                {body}
            </div>
            <i>{footer}</i>
        </div>
    );
};

export default withAccordion;
